module.exports = __webpack_public_path__ + "static/media/feature-image.b4a6b911.png";